import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './tufts-yext-researcher-item.css.lit';
import buttonLinkStyle from '../tufts-button/tufts-button.css.lit';
import { TuftsYextItem } from '../tufts-yext-item/tufts-yext-item';
import componentYextItemStyles from '../tufts-yext-item/tufts-yext-item.css.lit';
import { EntityDataStructure } from '../tufts-yext/tufts-yext-types';

/**
 * The Yext Item Researcher component.
 * @element tufts-yext-researcher-item
 */
@customElement('tufts-yext-researcher-item')
export class TuftsYextResearcherItem extends TuftsYextItem {
  static styles: CSSResultGroup = [
    buttonLinkStyle,
    componentYextItemStyles,
    componentStyles,
  ];

  breadcrumbsTemplate(): TemplateResult {
    return html`
      <tufts-breadcrumbs>
        <nav class="breadcrumb">
          <ol slot="breadcrumb">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/get-care">Get Care</a>
            </li>
            <li>
              <a href="/find-a-researcher">Find a Researcher</a>
            </li>
          </ol>
        </nav>
      </tufts-breadcrumbs>
    `;
  }
  templateCTA(response: EntityDataStructure) {
    return html`
      <tufts-icon-link>
        <div slot="icon">
          <tufts-icon library="system" name="download" size="100%"></tufts-icon>
        </div>
        <div slot="link">
          <a href=${this.createVcard(response)} download="${response.name}.vcf">
            Save contact
          </a>
        </div>
      </tufts-icon-link>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-yext-researcher-item': TuftsYextResearcherItem;
  }
}
